import { ITabItem } from "../interface/common";

export const tabNoteJob: ITabItem[] = [
  { tabName: 'tab_label_internal_notes', tabParam: 'internal_notes' },
  { tabName: 'tab_label_external_notes', tabParam: 'external_notes' },
  { tabName: 'tab_label_site_notes', tabParam: 'site_notes' },
];
